export default __webpack_public_path__ + "static/media/rocket_anim_10.94207306.png";